import { useRef } from 'react';

export function useConstant<T>(value: T): T {
  const { current: constant } = useRef<T>(value);
  return constant;
}
